<nz-skeleton
  [ngClass]="{ 'em-skeleton-white-background': isLoading }"
  [nzActive]="true"
  [nzLoading]="isLoading"
>
  <ng-container *ngFor="let item of elementHistoryDocuments$ | async; trackBy: trackByRef">
    <em-share-point-file-link-card
      [error]="(error$ | async) ?? ''"
      title="Element History Document"
      [item]="item"
    ></em-share-point-file-link-card>
  </ng-container>
</nz-skeleton>
